export const provideContext = (Provider, Component) => () => (
    <Provider>
        <Component />
    </Provider>
);
